<template>
    <u-icon v-bind="$attrs">arrow_{{direction}}</u-icon>
</template>

<script>
import UIcon from "@/components/publish/styles/icons/u-icon.vue";

export default {
    props: {
        direction: { type: String, default: "" },
    },
    components: {
        UIcon,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
